import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const StepperTitleWrapper = styled.div`
  margin: 30px 0;
`;

const StyledTitle = styled(Typography)`
  && {
    font-size: 18px;
    color: #212121;
    letter-spacing: 0.15px;
    font-weight: 500;
  }
`;

const StyledSubTitle = styled(Typography)`
  && {
    font-size: 12px;
    color: #616161;
    letter-spacing: 0.15px;
    font-weight: 500;
  }
`;

const StepperTitle = ({ title, subTitle }) => (
  <StepperTitleWrapper>
    <StyledTitle>{title}</StyledTitle>
    <StyledSubTitle>{subTitle}</StyledSubTitle>
  </StepperTitleWrapper>
);

export default StepperTitle;
